let t = null

export const debounce = function (fn, wait) {
  if(t !== null) {
    clearTimeout(t)
    t = null
  }

  t = setTimeout(() => {
    // 处理参数 去除 fn, wait
    let args = [...arguments].splice(2)
    fn.call(this, ...args)
    t = null
  }, wait)
}